import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

// Refresh the markers to make up for Elementor's JS resizing
const resetMarker = () => {
	window.setTimeout(() => {
		ScrollTrigger.refresh();
	}, 500);
};

// Animations for the Stadio page (=== page ID 74)
const initAnimations = () => {

	if (!document.body.classList.contains('page-id-74')) return;

	// register ScrollTrigger
	gsap.registerPlugin(ScrollTrigger);

	resetMarker();

	//////////////////////
	// Smooth text boxes
	//////////////////////

	const smoothText = document.querySelectorAll('.smooth-text');

	smoothText.forEach((text) => {
		gsap.from(text, {
			scrollTrigger: {
				trigger: text,
				start: 'top 75%',
				end: 'bottom center',
				// markers: true,
				scrub: true,
			},
			y: 50,
			opacity: 0,
		});
	});


	///////////////////////
	// Finishing variants
	///////////////////////

	const finishingTl = gsap.timeline({
		scrollTrigger: {
			trigger: '.variants',
			start: 'top 75%',
			end: 'top 35%',
			// markers: true,
			scrub: true,
		},
	});

	finishingTl.from('.variants-1', {
		x: -100,
		opacity: 0,
	}, 0);

	finishingTl.from('.variants-3', {
		x: 100,
		opacity: 0,
	}, 0);

	finishingTl.from('.variants-2', {
		opacity: 0,
	}, 0);

};
initAnimations();

// Animations for the Stadio page (=== page ID 133)
const initAnimationsCatro = () => {
	if (!document.body.classList.contains('page-id-133')) return;

	// Register ScrollTrigger
	gsap.registerPlugin(ScrollTrigger);

	resetMarker();

	///////////////////////
	// Big text animation
	///////////////////////

	const bigTextTimeline = gsap.timeline({
		scrollTrigger: {
			trigger: '.big-text__container',
			start: 'top 50%',
			end: 'center center',
			// markers: true,
			scrub: true,
		},
	});

	const bigTexts = document.querySelectorAll('.big-text p');

	bigTexts.forEach((text) => {
		bigTextTimeline.from(text, {
			opacity: 0,
			duration: 1,
		}, '>');
	});


	///////////////////////////
	// Table height animation
	///////////////////////////

	const currentHeight = document.querySelector('.current-height');

	// Tween
	gsap.to('.tableHeight__top', {
		y: '-75%',
		duration: 1,
		scrollTrigger: {
			trigger: '.tableHeight__container',
			start: 'center 75%',
			end: 'center 25%',
			// markers: true,
			scrub: 0.75,
			onUpdate: (self) => {
				if (currentHeight !== null) {
					currentHeight.textContent = `${Math.round(self.progress * 100 * 5 + 680)} mm`;
				}
			},
		},
	});


	///////////////////////////
	// Table height animation
	///////////////////////////

	const tableTopTl = gsap.timeline({
		scrollTrigger: {
			trigger: '.tabletop__animation',
			start: 'center 85%',
			end: 'center 50%',
			scrub: true,
			// markers: true,
		},
	});

	// Sizes: box size adjustment
	// const tableTopSizes: HTMLDivElement | null = document.querySelector('.tabletops__sizes');
	// if (tableTopSizes !== null) {
	// 	tableTopSizes.style.height = `${tableTopSizes.getBoundingClientRect().width * 0.55} px`;
	// }

	// Sizes: text elements
	const tableTopSizesTexts = document.querySelectorAll('.tabletops__sizes p');

	tableTopTl.from(tableTopSizesTexts.item(0), {
		opacity: 0,
	});

	tableTopTl.to('.tabletops__top--zoom1', {
		scaleX: 0.9,
	});

	tableTopTl.from(tableTopSizesTexts.item(1), {
		opacity: 0,
	}, '<');

	tableTopTl.to('.tabletops__top--zoom2', {
		scaleX: 0.8,
	});

	tableTopTl.from(tableTopSizesTexts.item(2), {
		opacity: 0,
	}, '<');

	tableTopTl.to('.tabletops__top--zoom3', {
		scaleX: 0.7,
	});

	tableTopTl.from(tableTopSizesTexts.item(3), {
		opacity: 0,
	}, '<');
};
initAnimationsCatro();

// Animations for the Sometimes page (=== page ID 62)
const initAnimationsSometimes = () => {
	if (!document.body.classList.contains('page-id-62')) return;

	// Register ScrollTrigger
	gsap.registerPlugin(ScrollTrigger);

	resetMarker();

	/////////////////////
	// Table animation //
	/////////////////////

	const questionTable: HTMLSpanElement | null = document.querySelector('.question__table');
	const questionSideboard: HTMLSpanElement | null = document.querySelector('.question__sideboard');

	gsap.to('.pullout__table', {
		scrollTrigger: {
			// markers: true,
			trigger: '.pullout',
			start: 'top 75%',
			end: 'center top',
			toggleActions: 'play pause resume pause',
		},
		x: '90%',
		duration: 2,
		ease: 'power1',
	});

	ScrollTrigger.create({
		trigger: questionTable as Element,
		start: 'top 75%',
		end: 'center 25%',
		// markers: true,
		onUpdate: (self) => {
			if (questionSideboard === null) return;
			questionSideboard.style.color = `hsl(0,0%,${Math.min(100 - self.progress * 70, 100)}%)`;
			if (questionTable === null) return;
			questionTable.style.color = `hsl(0,0%,${Math.min(30 + self.progress * 70, 100)}%)`;
		},
	});

	//////////////////////
	// Drawer animation //
	//////////////////////

	// TODO: drawer ani


	///////////////////////////
	// Standard Text Fade-In //
	///////////////////////////

	const fadeInText = document.querySelectorAll('.fade-in-text');

	fadeInText.forEach(textItem => {
		gsap.from(textItem, {
			opacity: 0,
			scrollTrigger: {
				trigger: textItem,
				scrub: true,
				// markers: true,
				start: 'top 75%',
				end: 'bottom 50%',
			},
		});
	});

	//////////////////////////////
	//  Duo Rotation Animation  //
	//////////////////////////////

	gsap.from('.duo-rotation .elementor-column-wrap', {
		rotate: '10deg',
		scrollTrigger: {
			trigger: '.duo-rotation',
			markers: true,
			scrub: true,
		}
	});

};
initAnimationsSometimes();